/**
 * @generated SignedSource<<52191c41163470b0407ac6063fe8676c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GoogleSettings_settings$data = {
  readonly google: {
    readonly analyticsId: string | null;
    readonly apiKey: string | null;
    readonly loginClientId: string | null;
    readonly loginClientSecret: string | null;
  } | null;
  readonly " $fragmentType": "GoogleSettings_settings";
};
export type GoogleSettings_settings$key = {
  readonly " $data"?: GoogleSettings_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"GoogleSettings_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoogleSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GoogleSettings",
      "kind": "LinkedField",
      "name": "google",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "analyticsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "apiKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loginClientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loginClientSecret",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "2ced9e35284545cb531cbad58f103b68";

export default node;
